import React, { useLayoutEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { getColorClass } from "../../../functions/functions";
import StudentBreadcrumbs from "./StudentBreadcrumbs";

// Hook for pages that need to override the page header dynamically
// e.g. useStudentPageHeader({ chapterId: 5, chapterName: "Intro" }, [chapterId])
export const useStudentPageHeader = (config, dependencies = []) => {
	const outletContext = useOutletContext();
	const setStudentPageHeader = outletContext?.setStudentPageHeader;

	useLayoutEffect(() => {
		if (!setStudentPageHeader) return undefined;
		setStudentPageHeader(config || {});
		return () => setStudentPageHeader({});
	}, [setStudentPageHeader, ...dependencies]);
};

const StudentPageHeader = ({ header }) => {
	const { showChapterBlock, showBreadcrumbs, chapterId, chapterName } = header || {};

	// Nothing to render
	if (!showChapterBlock && !showBreadcrumbs) return null;

	return (
		<div className="container mx-auto">
			{/* Breadcrumbs — always above chapter title */}
			{showBreadcrumbs && <StudentBreadcrumbs />}

			{/* Chapter block — colored number box + chapter title */}
			{showChapterBlock && (
				<>
					<div
						style={{ backgroundColor: getColorClass(chapterId, "colorcode") }}
						className="text-white w-12 lg:w-36 roboto-slab font-bold text-4xl flex justify-center items-end pb-7 absolute right-0 top-0 h-[11rem]"
						id="top"
					>
						{chapterId}
					</div>
					<div className="flex justify-between items-center">
						<h1
							style={{ color: getColorClass(chapterId, "colorcode") }}
							className="text-base lg:text-2xl underline underline-offset-4 font-extrabold uppercase w-4/5 lg:w-auto m-0"
						>
							{chapterName}
						</h1>
					</div>
				</>
			)}
		</div>
	);
};

export default StudentPageHeader;
